// date lib
import formatISODate from '../../date/formatters/formatISO.formatter.date';

const strategicRiskItemsDataMap = (company) => {
  const localFinancialsType = [
    ...(company?.financials?.report?.localFinancialStatements || []),
  ]?.[0]?.type;

  const {categories, entries} = [
    ...(company?.financials?.report?.localFinancialStatements || []),
  ]
    .filter(({type}) => type === localFinancialsType)
    .reduce(
      (combined, current) => {
        const updatedCategories = [
          ...combined.categories,
          {
            key: current.yearEndDate,
            label: formatISODate({
              date: current.yearEndDate,
              dateFormat: 'MM/dd/yy',
            }),
          },
        ];

        const entries = Object.entries(current?.ratios || {}).reduce(
          (combinedEntries, [entryKey, entryValue]) => {
            if (
              ![
                'capitalCap',
                'netOperatingProfitBeforeTax',
                'netOperatingProfitAfterTax',
                'cashOperatingProfitAfterTax',
                'totalGrossCapital',
                'capAverage3Yr',
                'nopbtAverage3Yr',
                'nopatAverage3Yr',
                'copatAverage3Yr',
                'tgcAverage3Yr',
                'averagePreTaxReturnRisk3Yr',
                'averageAfterTaxReturnRisk3Yr',
                'averageTotalGrossReturnRisk3Yr',
                'capAverage5Yr',
                'nopbtAverage5Yr',
                'nopatAverage5Yr',
                'copatAverage5Yr',
                'tgcAverage5Yr',
                'averagePreTaxReturnRisk5Yr',
                'averageAfterTaxReturnRisk5Yr',
                'totalGrossReturnRisk5Yr',
              ].includes(entryKey)
            )
              return combinedEntries;
            const entry = [...combined.entries].find(
              (existingEntry) => existingEntry.entry.value === entryKey
            ) || {
              entry: {
                value: entryKey,
                type: 'key',
              },
            };
            entry[current.yearEndDate] = {
              value: entryValue,
              type: [
                'averagePreTaxReturnRisk3Yr',
                'averageAfterTaxReturnRisk3Yr',
                'averageTotalGrossReturnRisk3Yr',
                'averagePreTaxReturnRisk5Yr',
                'averageAfterTaxReturnRisk5Yr',
                'totalGrossReturnRisk5Yr',
              ].includes(entryKey)
                ? 'percentage'
                : 'currency',
            };
            return [...combinedEntries, entry];
          },
          []
        );

        return {
          categories: updatedCategories,
          entries,
        };
      },
      {
        categories: [],
        entries: [],
      }
    );

  const updatedCategories = [
    {
      key: 'entry',
      label: '',
    },
    ...categories.reverse(),
  ];
  const updatedEntries = [...entries].filter((entry) =>
    Object.entries(entry).every(
      ([key, value]) => key === 'entry' || !!value?.value
    )
  );
  return {
    categories: updatedCategories,
    entries: updatedEntries,
  };
};

export default strategicRiskItemsDataMap;
